import React from "react";

function Color_Shades() {
  return (
    <div>
      <h1>Color_Shades Component</h1>
      <p>This is the Color Shades tutorial page content.</p>
    </div>
  );
}

export default Color_Shades;
